package ir.alirezaivaz.finglish.ui.widgets

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ir.alirezaivaz.kartam.extensions.handPointerIcon

@Composable
fun SwitchItem(
    title: String,
    isChecked: Boolean,
    onCheckedChanged: (isChecked: Boolean) -> Unit
) {
    Row(
        modifier = Modifier
            .handPointerIcon()
            .fillMaxWidth()
            .clickable {
                onCheckedChanged(!isChecked)
            },
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            title,
            style = MaterialTheme.typography.titleMedium,
            modifier = Modifier.padding(start = 16.dp)
        )
        Switch(
            isChecked,
            modifier = Modifier.padding(end = 16.dp),
            onCheckedChange = {
                onCheckedChanged(!isChecked)
            }
        )
    }
}

